import { useState } from "react";
import React from "react";
import { Box, Button, Paper, Stack, Typography, Divider } from "@mui/material";
import { AddOutlined, SearchOutlined } from "@mui/icons-material";
import BoxInput from "./BoxInput";
import { tokens, radius } from "../theme/theme";

/**
 * Filter bar above the objects table. A
 * `queryObjects({ street, rooms, region, heating, fromCost, toCost, phone })`
 * payload goes out on "Знайти". The phone is matched by digits, so any
 * spelling of the number finds it.
 */
const Header = ({ onAddItem, queryObjects, regionSearchTerms, streetSearchTerms, admin }) => {
  const [street, setStreet] = useState("");
  const [rooms, setRooms] = useState(-1);
  const [regions, setRegions] = useState("");
  const [heating, setHeating] = useState("");
  const [fromCost, setCostFrom] = useState(-1);
  const [toCost, setCostTo] = useState(-1);
  const [phone, setPhone] = useState("");

  const search = () =>
    queryObjects({
      street: street,
      rooms: rooms,
      region: regions,
      heating: heating,
      fromCost: fromCost,
      toCost: toCost,
      phone: phone,
    });

  return (
    <Paper
      elevation={0}
      sx={{
        mx: { xs: 1, md: 2 },
        mt: { xs: 1, md: 2 },
        // 12px, matching the gap under the view toggle below it.
        mb: 1.5,
        p: { xs: 1.5, md: 2 },
        borderRadius: radius.lg,
        border: "1px solid " + tokens.line,
      }}
    >
      <Stack
        direction="row"
        spacing={1.5}
        alignItems="center"
        flexWrap="wrap"
        useFlexGap
      >
        {admin && (
          <React.Fragment>
            <Button variant="contained" startIcon={<AddOutlined />} onClick={onAddItem}>
              Додати об'єкт
            </Button>
            <Divider
              orientation="vertical"
              flexItem
              sx={{ display: { xs: "none", lg: "block" } }}
            />
          </React.Fragment>
        )}

        <BoxInput
          label="Вулиця"
          inputWidth="170px"
          type="text"
          items={streetSearchTerms}
          onChange={(newValue) => setStreet(newValue)}
        />
        <BoxInput
          label="Кімнат"
          inputWidth="100px"
          type="number"
          items={["1", "2", "3", "4"]}
          onChange={(newValue) => setRooms(newValue)}
        />
        <BoxInput
          label="Район"
          inputWidth="150px"
          type="text"
          items={regionSearchTerms}
          onChange={(newValue) => setRegions(newValue)}
        />
        <BoxInput
          label="Опалення"
          inputWidth="150px"
          type="text"
          items={["Центральне", "Індивідуальне"]}
          onChange={(newValue) => setHeating(newValue)}
        />
        <BoxInput
          label="Телефон"
          inputWidth="150px"
          type="tel"
          items={[]}
          onChange={(newValue) => setPhone(newValue)}
        />

        <Stack direction="row" spacing={1} alignItems="center">
          <Typography variant="caption" sx={{ whiteSpace: "nowrap" }}>
            Ціна
          </Typography>
          <BoxInput
            label="від"
            inputWidth="105px"
            type="number"
            items={["6000"]}
            onChange={(newValue) => setCostFrom(newValue)}
          />
          <BoxInput
            label="до"
            inputWidth="105px"
            type="number"
            items={["12000"]}
            onChange={(newValue) => setCostTo(newValue)}
          />
        </Stack>

        <Box sx={{ ml: { lg: "auto" } }}>
          <Button variant="outlined" startIcon={<SearchOutlined />} onClick={search}>
            Знайти
          </Button>
        </Box>
      </Stack>
    </Paper>
  );
};

export default Header;
